module.exports = __webpack_public_path__ + "img/制御工学3_5_5.6fe26839.png";